import { render, staticRenderFns } from "./title2.vue?vue&type=template&id=57b5ae75&scoped=true&"
import script from "./title2.vue?vue&type=script&lang=js&"
export * from "./title2.vue?vue&type=script&lang=js&"
import style0 from "./title2.vue?vue&type=style&index=0&id=57b5ae75&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5ae75",
  null
  
)

export default component.exports